import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=d1bb09a0&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import "./Dashboard.vue?vue&type=style&index=0&id=d1bb09a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bb09a0",
  null
  
)

export default component.exports